import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const EventService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/event", data);
    return response.data;
  },
  update: async (updatedData) => {
    try {
      const response = await apiService.put(`/event`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({ onlyActive }) => {
    const params = new URLSearchParams();

    if (onlyActive !== "") {
      params.append("onlyActive", onlyActive);
    }

    const response = await apiService.get(`/event?${params.toString()}`);
    return response.data;
  },

  getDetail: async (id) => {
    const response = await apiService.get(`/event/${id}`);
    return response.data;
  },
  getBySlug: async (id) => {
    const response = await apiService.get(`/event/slug?slug=${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/event/${id}`);
    return response.data;
  },
  createForm: async (data) => {
    const response = await apiService.post("/eventsforms", data);
    return response.data;
  },
  getFormList: async ({ email = "", phoneNumber = "", status = null } = {}) => {
    const params = new URLSearchParams({
      ...(email && { email }),
      ...(phoneNumber && { phoneNumber }),

      ...(status !== null && { status: status }),
    });
    const response = await apiService.get(`/eventsforms?${params.toString()}`);
    return response.data;
  },
  updateStatus: async (updatedData) => {
    try {
      const response = await apiService.put(`/eventsforms`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default EventService;
